module.exports = __webpack_public_path__ + "static/img/date.b84d8922.png";